import { Component, OnInit } from '@angular/core';
import { World } from './world/World';
import { UiManagerService } from './ui/ui-manager.service';
import { WorldService } from './ui/word-controller/world.service';
import { environment } from '../environments/environment';
import { PlayerService } from './character/player.service';
import { WantedLevelService } from './world/WantedLevelService';
import { GameStateServiceService } from './world/GameStateService.service';
import { ScoreService } from './world/score.service';
import { EscapeService } from './world/EscapeService';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'GTAjs';
    word: World;

    constructor(public UIManagerService: UiManagerService,
                public worldService: WorldService,
                public playerService: PlayerService,
                public wantedLevelService: WantedLevelService,
                public gameStateService: GameStateServiceService,
                public scoreService: ScoreService,
                public escapeService: EscapeService) {
    }

    ngOnInit(): void {
        this.word = new World(
            this.worldService,
            this.UIManagerService,
            this.playerService,
            this.wantedLevelService,
            this.gameStateService,
            this.scoreService,
            this.escapeService,
            environment.worldPath
        );
    }
}
